import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, createVNode as _createVNode, createCommentVNode as _createCommentVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = { class: "container" }
const _hoisted_2 = { class: "row" }
const _hoisted_3 = { class: "col-4" }
const _hoisted_4 = {
  key: 0,
  class: "mt-4"
}
const _hoisted_5 = { class: "mb-3" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("div", { class: "badge badge-primary" }, "Documentation", -1)
const _hoisted_7 = /*#__PURE__*/_createElementVNode("div", { class: "badge badge-red ml-2" }, "PDF", -1)
const _hoisted_8 = /*#__PURE__*/_createElementVNode("div", { class: "badge badge-red ml-2" }, "PDF", -1)
const _hoisted_9 = /*#__PURE__*/_createElementVNode("div", { class: "badge badge-red ml-2" }, "PDF", -1)
const _hoisted_10 = {
  key: 0,
  class: "mb-3"
}
const _hoisted_11 = { class: "badge badge-dark" }
const _hoisted_12 = /*#__PURE__*/_createElementVNode("div", { class: "badge badge-info ml-2" }, "EXE", -1)
const _hoisted_13 = /*#__PURE__*/_createElementVNode("div", { class: "badge badge-danger ml-2" }, "PDF", -1)
const _hoisted_14 = {
  key: 1,
  class: "mb-3"
}
const _hoisted_15 = { class: "badge badge-dark" }
const _hoisted_16 = /*#__PURE__*/_createElementVNode("div", { class: "badge badge-info ml-2" }, "EXE", -1)
const _hoisted_17 = /*#__PURE__*/_createElementVNode("div", { class: "badge badge-danger ml-2" }, "PDF", -1)
const _hoisted_18 = {
  key: 2,
  class: "mb-3"
}
const _hoisted_19 = { class: "badge badge-dark" }
const _hoisted_20 = /*#__PURE__*/_createElementVNode("div", { class: "badge badge-warning ml-2" }, "ZIP", -1)
const _hoisted_21 = /*#__PURE__*/_createElementVNode("div", { class: "badge badge-danger ml-2" }, "PDF", -1)
const _hoisted_22 = {
  key: 3,
  class: "mb-3"
}
const _hoisted_23 = { class: "badge badge-dark" }
const _hoisted_24 = /*#__PURE__*/_createElementVNode("div", { class: "badge badge-warning ml-2" }, "ZIP", -1)
const _hoisted_25 = /*#__PURE__*/_createElementVNode("div", { class: "badge badge-warning ml-2" }, "ZIP", -1)
const _hoisted_26 = /*#__PURE__*/_createElementVNode("div", { class: "badge badge-danger ml-2" }, "PDF", -1)
const _hoisted_27 = {
  key: 4,
  class: "mb-3"
}
const _hoisted_28 = { class: "badge badge-dark" }
const _hoisted_29 = /*#__PURE__*/_createElementVNode("div", { class: "badge badge-warning ml-2" }, "ZIP", -1)
const _hoisted_30 = /*#__PURE__*/_createElementVNode("div", { class: "badge badge-danger ml-2" }, "PDF", -1)
const _hoisted_31 = { class: "col-8" }
const _hoisted_32 = { class: "ml-auto badge badge-dark" }
const _hoisted_33 = { class: "d-flex" }
const _hoisted_34 = { class: "ml-auto badge badge-secondary" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_b_list_group_item = _resolveComponent("b-list-group-item")!
  const _component_b_list_group = _resolveComponent("b-list-group")!
  const _component_b_alert = _resolveComponent("b-alert")!
  const _component_b_nav_item = _resolveComponent("b-nav-item")!
  const _component_b_nav = _resolveComponent("b-nav")!
  const _component_b_button = _resolveComponent("b-button")!
  const _component_b_card_header = _resolveComponent("b-card-header")!
  const _component_b_card_body = _resolveComponent("b-card-body")!
  const _component_b_collapse = _resolveComponent("b-collapse")!
  const _component_b_card = _resolveComponent("b-card")!
  const _directive_b_toggle = _resolveDirective("b-toggle")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createVNode(_component_b_list_group, null, {
            default: _withCtx(() => [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.versionList, (item, index) => {
                return (_openBlock(), _createBlock(_component_b_list_group_item, {
                  onClick: ($event: any) => (_ctx.getpatchnote(item)),
                  key: index,
                  button: "",
                  class: _normalizeClass(["d-flex align-items-center", item.version == _ctx.versionSelect ? 'active' : '']),
                  "active-class": "bg-dark"
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(item.name) + " ", 1),
                    _createElementVNode("span", {
                      class: _normalizeClass(["ml-auto badge", item.version == _ctx.versionSelect ? 'badge-white' : 'badge-dark'])
                    }, _toDisplayString(item.date), 3)
                  ], undefined, true),
                  _: 2
                }, 1032, ["onClick", "class"]))
              }), 128))
            ], undefined, true),
            _: 1
          }),
          (_ctx.filesInfo)
            ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                _createElementVNode("div", _hoisted_5, [
                  _hoisted_6,
                  _createVNode(_component_b_list_group, null, {
                    default: _withCtx(() => [
                      (_ctx.filesInfo.documentation.preRequis)
                        ? (_openBlock(), _createBlock(_component_b_list_group_item, {
                            key: 0,
                            button: "",
                            onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.showFile(_ctx.filesInfo.documentation.preRequis))),
                            class: "d-flex align-items-center justify-content-between"
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(_ctx.$t('preRequisite')) + " ", 1),
                              _hoisted_7
                            ], undefined, true),
                            _: 1
                          }))
                        : _createCommentVNode("", true),
                      (_ctx.filesInfo.documentation.avantMigration)
                        ? (_openBlock(), _createBlock(_component_b_list_group_item, {
                            key: 1,
                            button: "",
                            onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.showFile(_ctx.filesInfo.documentation.avantMigration))),
                            class: "d-flex align-items-center justify-content-between"
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(_ctx.$t('beforeConsult')) + " ", 1),
                              _hoisted_8
                            ], undefined, true),
                            _: 1
                          }))
                        : _createCommentVNode("", true),
                      (_ctx.filesInfo.documentation.informationParVersion)
                        ? (_openBlock(), _createBlock(_component_b_list_group_item, {
                            key: 2,
                            button: "",
                            onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.showFile(_ctx.filesInfo.documentation.informationParVersion))),
                            class: "d-flex align-items-center justify-content-between"
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(_ctx.$t('importantInfo')) + " ", 1),
                              _hoisted_9
                            ], undefined, true),
                            _: 1
                          }))
                        : _createCommentVNode("", true)
                    ], undefined, true),
                    _: 1
                  })
                ]),
                (_ctx.user.admin || (_ctx.user.company.client && _ctx.user.company.deployment == 'On_Premise'))
                  ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
                      _createElementVNode("div", _hoisted_11, _toDisplayString(_ctx.$t('install')) + " SOLU-QIQ Base", 1),
                      _createVNode(_component_b_list_group, null, {
                        default: _withCtx(() => [
                          (_ctx.filesInfo.base.installation)
                            ? (_openBlock(), _createBlock(_component_b_list_group_item, {
                                key: 0,
                                button: "",
                                onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.showFile(_ctx.filesInfo.base.installation))),
                                class: "d-flex align-items-center justify-content-between"
                              }, {
                                default: _withCtx(() => [
                                  _createTextVNode(_toDisplayString(_ctx.$t('installOf')) + " SOLU-QIQ Base ", 1),
                                  _hoisted_12
                                ], undefined, true),
                                _: 1
                              }))
                            : _createCommentVNode("", true),
                          (_ctx.filesInfo.base.installation)
                            ? (_openBlock(), _createBlock(_component_b_list_group_item, {
                                key: 1,
                                button: "",
                                onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.showFile('Installation de SOLU-QIQ Base.pdf'))),
                                class: "d-flex align-items-center justify-content-between"
                              }, {
                                default: _withCtx(() => [
                                  _createTextVNode(_toDisplayString(_ctx.$t('install')) + " SOLU-QIQ Base ", 1),
                                  _hoisted_13
                                ], undefined, true),
                                _: 1
                              }))
                            : _createCommentVNode("", true)
                        ], undefined, true),
                        _: 1
                      })
                    ]))
                  : _createCommentVNode("", true),
                (_ctx.user.admin || (_ctx.user.company.client && _ctx.user.company.deployment == 'On_Premise'))
                  ? (_openBlock(), _createElementBlock("div", _hoisted_14, [
                      _createElementVNode("div", _hoisted_15, _toDisplayString(_ctx.$t('update')) + " SOLU-QIQ Base", 1),
                      _createVNode(_component_b_list_group, null, {
                        default: _withCtx(() => [
                          (_ctx.filesInfo.base.patch)
                            ? (_openBlock(), _createBlock(_component_b_list_group_item, {
                                key: 0,
                                button: "",
                                onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.showFile(_ctx.filesInfo.base.patch))),
                                class: "d-flex align-items-center justify-content-between"
                              }, {
                                default: _withCtx(() => [
                                  _createTextVNode(_toDisplayString(_ctx.$t('lastPatchFor')) + " SOLU-QIQ Base ", 1),
                                  _hoisted_16
                                ], undefined, true),
                                _: 1
                              }))
                            : _createCommentVNode("", true),
                          (_ctx.filesInfo.base.installation)
                            ? (_openBlock(), _createBlock(_component_b_list_group_item, {
                                key: 1,
                                button: "",
                                onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.showFile('Mise à jour de SOLU-QIQ Base.pdf'))),
                                class: "d-flex align-items-center justify-content-between"
                              }, {
                                default: _withCtx(() => [
                                  _createTextVNode(_toDisplayString(_ctx.$t('update')) + " SOLU-QIQ Base ", 1),
                                  _hoisted_17
                                ], undefined, true),
                                _: 1
                              }))
                            : _createCommentVNode("", true)
                        ], undefined, true),
                        _: 1
                      })
                    ]))
                  : _createCommentVNode("", true),
                (_ctx.user.admin || (_ctx.user.company.client && _ctx.user.company.deployment == 'On_Premise'))
                  ? (_openBlock(), _createElementBlock("div", _hoisted_18, [
                      _createElementVNode("div", _hoisted_19, _toDisplayString(_ctx.$t('install')) + " - " + _toDisplayString(_ctx.$t('update')) + " SOLU-QIQ Web Contributeur", 1),
                      _createVNode(_component_b_list_group, null, {
                        default: _withCtx(() => [
                          (_ctx.filesInfo.web.installation)
                            ? (_openBlock(), _createBlock(_component_b_list_group_item, {
                                key: 0,
                                button: "",
                                onClick: _cache[7] || (_cache[7] = ($event: any) => (_ctx.showFile(_ctx.filesInfo.web.installation))),
                                class: "d-flex align-items-center justify-content-between"
                              }, {
                                default: _withCtx(() => [
                                  _createTextVNode(_toDisplayString(_ctx.$t('installOf')) + " SQWeb Contributeur ", 1),
                                  _hoisted_20
                                ], undefined, true),
                                _: 1
                              }))
                            : _createCommentVNode("", true),
                          (_ctx.filesInfo.web.installation)
                            ? (_openBlock(), _createBlock(_component_b_list_group_item, {
                                key: 1,
                                button: "",
                                onClick: _cache[8] || (_cache[8] = ($event: any) => (_ctx.showFile('Déploiement de SOLU-QIQ Web Contributeur.pdf'))),
                                class: "d-flex align-items-center justify-content-between"
                              }, {
                                default: _withCtx(() => [
                                  _createTextVNode(_toDisplayString(_ctx.$t('install')) + " - " + _toDisplayString(_ctx.$t('update')) + " SQWeb Contributeur ", 1),
                                  _hoisted_21
                                ], undefined, true),
                                _: 1
                              }))
                            : _createCommentVNode("", true)
                        ], undefined, true),
                        _: 1
                      })
                    ]))
                  : _createCommentVNode("", true),
                (_ctx.user.admin || (_ctx.user.company.client && _ctx.user.company.deployment == 'On_Premise'))
                  ? (_openBlock(), _createElementBlock("div", _hoisted_22, [
                      _createElementVNode("div", _hoisted_23, _toDisplayString(_ctx.$t('updateSQServices')), 1),
                      _createVNode(_component_b_list_group, null, {
                        default: _withCtx(() => [
                          (_ctx.filesInfo.services.installationSQAuto)
                            ? (_openBlock(), _createBlock(_component_b_list_group_item, {
                                key: 0,
                                button: "",
                                onClick: _cache[9] || (_cache[9] = ($event: any) => (_ctx.showFile(_ctx.filesInfo.services.installationSQAuto))),
                                class: "d-flex align-items-center justify-content-between"
                              }, {
                                default: _withCtx(() => [
                                  _createTextVNode(_toDisplayString(_ctx.$t('installSQAuto')) + " ", 1),
                                  _hoisted_24
                                ], undefined, true),
                                _: 1
                              }))
                            : _createCommentVNode("", true),
                          (_ctx.filesInfo.services.installationGrapheAuto)
                            ? (_openBlock(), _createBlock(_component_b_list_group_item, {
                                key: 1,
                                button: "",
                                onClick: _cache[10] || (_cache[10] = ($event: any) => (_ctx.showFile(_ctx.filesInfo.services.installationGrapheAuto))),
                                class: "d-flex align-items-center justify-content-between"
                              }, {
                                default: _withCtx(() => [
                                  _createTextVNode(_toDisplayString(_ctx.$t('installGA')) + " ", 1),
                                  _hoisted_25
                                ], undefined, true),
                                _: 1
                              }))
                            : _createCommentVNode("", true),
                          (_ctx.filesInfo.web.installation)
                            ? (_openBlock(), _createBlock(_component_b_list_group_item, {
                                key: 2,
                                button: "",
                                onClick: _cache[11] || (_cache[11] = ($event: any) => (_ctx.showFile('Installation et mise à jour des services SOLU-QIQ.pdf'))),
                                class: "d-flex align-items-center justify-content-between"
                              }, {
                                default: _withCtx(() => [
                                  _createTextVNode(" Installation et mise à jour des services SOLU-QIQ "),
                                  _hoisted_26
                                ], undefined, true),
                                _: 1
                              }))
                            : _createCommentVNode("", true)
                        ], undefined, true),
                        _: 1
                      })
                    ]))
                  : _createCommentVNode("", true),
                (_ctx.filesInfo.API.installation && (_ctx.user.admin || (_ctx.user.company.client && _ctx.user.company.deployment == 'On_Premise')))
                  ? (_openBlock(), _createElementBlock("div", _hoisted_27, [
                      _createElementVNode("div", _hoisted_28, _toDisplayString(_ctx.$t('updateWAPI')) + " :", 1),
                      _createVNode(_component_b_list_group, null, {
                        default: _withCtx(() => [
                          _createVNode(_component_b_list_group_item, {
                            onClick: _cache[12] || (_cache[12] = ($event: any) => (_ctx.showFile(_ctx.filesInfo.API.installation))),
                            button: "",
                            class: "d-flex align-items-center justify-content-between"
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(_ctx.$t('installOf')) + " SOLU-QIQ Web API ", 1),
                              _hoisted_29
                            ], undefined, true),
                            _: 1
                          }),
                          _createVNode(_component_b_list_group_item, {
                            onClick: _cache[13] || (_cache[13] = ($event: any) => (_ctx.showFile('Déploiement de SOLU-QIQ Web API.pdf'))),
                            button: "",
                            class: "d-flex align-items-center justify-content-between"
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(_ctx.$t('install')) + " SOLU-QIQ Web API ", 1),
                              _hoisted_30
                            ], undefined, true),
                            _: 1
                          })
                        ], undefined, true),
                        _: 1
                      })
                    ]))
                  : _createCommentVNode("", true)
              ]))
            : _createCommentVNode("", true)
        ]),
        _createElementVNode("div", _hoisted_31, [
          (_ctx.Patchnote.commentaire)
            ? (_openBlock(), _createBlock(_component_b_alert, {
                key: 0,
                variant: "warning",
                show: ""
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.Patchnote.commentaire), 1)
                ], undefined, true),
                _: 1
              }))
            : _createCommentVNode("", true),
          _createVNode(_component_b_nav, {
            class: "custom-nav-pills custom-nav-pills-s rounded mb-3",
            pills: "",
            justified: ""
          }, {
            default: _withCtx(() => [
              _createVNode(_component_b_nav_item, {
                active: 'versions_SQBase' == _ctx.mode ? true : false,
                onClick: _cache[14] || (_cache[14] = ($event: any) => (_ctx.setMode('versions_SQBase')))
              }, {
                default: _withCtx(() => [
                  _createTextVNode(" SOLU-QiQ Base ")
                ], undefined, true),
                _: 1
              }, 8, ["active"]),
              _createVNode(_component_b_nav_item, {
                active: 'versions_SQWeb' == _ctx.mode ? true : false,
                onClick: _cache[15] || (_cache[15] = ($event: any) => (_ctx.setMode('versions_SQWeb')))
              }, {
                default: _withCtx(() => [
                  _createTextVNode(" SOLU-QiQ Web Contributeur ")
                ], undefined, true),
                _: 1
              }, 8, ["active"])
            ], undefined, true),
            _: 1
          }),
          _createElementVNode("div", null, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.PatchnoteMode, (item, index) => {
              return (_openBlock(), _createBlock(_component_b_card, {
                "no-body": "",
                class: "mb-1",
                key: index
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_b_card_header, {
                    "header-tag": "header",
                    class: "p-1",
                    role: "tab"
                  }, {
                    default: _withCtx(() => [
                      _withDirectives((_openBlock(), _createBlock(_component_b_button, {
                        class: "d-flex align-items-center",
                        href: "#",
                        show: "",
                        variant: "light"
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(item.version) + " ", 1),
                          _createElementVNode("span", _hoisted_32, _toDisplayString(item.date), 1)
                        ], undefined, true),
                        _: 2
                      }, 1024)), [
                        [_directive_b_toggle, 'accordion-' + index]
                      ])
                    ], undefined, true),
                    _: 2
                  }, 1024),
                  _createVNode(_component_b_collapse, {
                    id: 'accordion-' + index,
                    visible: index == 0 ? true : false,
                    accordion: 'accordion-' + index,
                    role: "tabpanel"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_b_card_body, null, {
                        default: _withCtx(() => [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item.historique, (type, typeIndex) => {
                            return (_openBlock(), _createElementBlock("div", { key: typeIndex }, [
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(type, (fix, index) => {
                                return (_openBlock(), _createElementBlock("div", {
                                  class: _normalizeClass(["ml-auto mb-1 p-2 rounded", typeIndex ==  'correction' ? 'bg-light ' : 'bg-light']),
                                  key: index
                                }, [
                                  _createElementVNode("div", _hoisted_33, [
                                    _createElementVNode("span", {
                                      class: _normalizeClass(["mr-1 badge", typeIndex ==  'correction' ? 'badge-dark' : 'badge-success'])
                                    }, _toDisplayString(typeIndex ==  'correction' ? 'Ticket' : 'Evol'), 3),
                                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(fix.ticket, (ticket, ticketIndex) => {
                                      return (_openBlock(), _createElementBlock("span", {
                                        class: "mr-1 badge badge-primary",
                                        key: ticketIndex
                                      }, _toDisplayString(ticket), 1))
                                    }), 128)),
                                    _createElementVNode("span", _hoisted_34, _toDisplayString(item.date), 1)
                                  ]),
                                  (typeIndex ==  'correction')
                                    ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                        _createTextVNode(_toDisplayString(fix.text), 1)
                                      ], 64))
                                    : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                                        _createTextVNode(_toDisplayString(fix), 1)
                                      ], 64))
                                ], 2))
                              }), 128))
                            ]))
                          }), 128))
                        ], undefined, true),
                        _: 2
                      }, 1024)
                    ], undefined, true),
                    _: 2
                  }, 1032, ["id", "visible", "accordion"])
                ], undefined, true),
                _: 2
              }, 1024))
            }), 128))
          ])
        ])
      ])
    ])
  ]))
}